import type { CommandInitFunction } from '../../types/CommandInitFunction.js';
import type { UnlinkOptions } from './types/UnlinkOptions.js';
import { reusedOptions } from '../../utilities/reusedOptions.js';

/** Defines the "unlink" verb. */
export const init: CommandInitFunction = (program) => {
  program.addSubCommand<UnlinkOptions>({
    name: 'unlink',
    description: 'Unlinks the package(s) found within the current folder from a "cloudpack start" session.',
    options: {
      logResolveMap: reusedOptions.logResolveMap(),
    },
    getExecutor: () => import('./execute.js'),
  });
};
